import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import MetricEvaluationFactorServices from "./MetricEvaluationFactor.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getEvaluationFactor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_EVALUATION_FACTOR,
      payload: true,
    });
    let resp;
    if(filters.filter_2&& filters.filter_2!==""){
      resp = await MetricEvaluationFactorServices.getEvaluationFactor(filters);
    }
    const respAll = await MetricEvaluationFactorServices.getEvaluationFactor({});
    let temp = {data:[]};
    respAll&&respAll.data.data.map((item)=>{
      if(!temp.data.find(t=>t.anio===item.anio)){
        temp.data.push(item)
      }
    })
    dispatch({
      type: actions.GET_EVALUATION_FACTOR,
      payload: {
        evaluationFactor:filters.filter_2&& filters.filter_2!==""?resp.data:{data:[],count:0},
        evaluationFactorAll:respAll.data,
        evaluationFactorAnio:temp
      },
    });
    dispatch({
      type: actions.EVALUATION_FACTOR_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.EVALUATION_FACTOR_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_EVALUATION_FACTOR,
      payload: false,
    });
  }
};

export const saveEvaluationFactor = (req, setShowModal, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EVALUATION_FACTOR,
      payload: true,
    });
    const resp = await MetricEvaluationFactorServices.saveEvaluationFactor(req);
    const { data, count } = getState().metricEvaluationFactor.evaluationFactor;
    const { data: dataAll, count: countAll } = getState().metricEvaluationFactor.evaluationFactorAll;
    const { data: dataAnio } = getState().metricEvaluationFactor.evaluationFactorAnio;
    const _data = [...data, resp.data];
    const _dataAll = [...dataAll, resp.data];
    let _dataAnio = dataAnio
    if(!_dataAnio.find(t=>t.anio===resp.data.anio)){
      _dataAnio.push(resp.data)
    }
    if(_data[count]){
      setInicialValorMinimo(_data[count].valor_maximo + 1)
    }else{
      setInicialValorMinimo(0)
    }

    dispatch({
      type: actions.GET_EVALUATION_FACTOR,
      payload: {
        evaluationFactor:{count: count + 1,data: _data},
        evaluationFactorAll:{count: countAll + 1,data: _dataAll},
        evaluationFactorAnio: {data: _dataAnio}
      },
    });
    dispatch({
      type: actions.FORM_EVALUATION_FACTOR_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_EVALUATION_FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_EVALUATION_FACTOR,
      payload: false,
    });
  }
};

export const editEvaluationFactor = (req, index, setShowModal, offset) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_EVALUATION_FACTOR,
        payload: true,
      });
      const resp = await MetricEvaluationFactorServices.editEvaluationFactor(req.id, req);
      const { data, count } = getState().metricEvaluationFactor.evaluationFactor;
      const { data: dataAll, count: countAll } = getState().metricEvaluationFactor.evaluationFactorAll;
      const { data: dataAnio } = getState().metricEvaluationFactor.evaluationFactorAnio;
      let _data = data.slice();
      let _dataAll = dataAll.slice();
      _data[index] = resp.data;
      _dataAll[index+offset] = resp.data;
      if(dataAll[index+1]){
        const _req = {
          valor_minimo: parseInt(req.valor_maximo) + 1,
          valor_maximo: dataAll[index+1].valor_maximo,
          tipo_criterio: dataAll[index+1].tipo_criterio,
          descripcion: dataAll[index+1].descripcion
        }
        const _resp = await MetricEvaluationFactorServices.editEvaluationFactor(dataAll[index+1].id, _req);
        _data[index+1] = _resp.data;
      }
      dispatch({
        type: actions.GET_EVALUATION_FACTOR,
        payload: {
          evaluationFactor:{data: _data,count: count},
          evaluationFactorAll:{data: _dataAll,count: countAll},
          evaluationFactorAnio: {data: dataAnio}
        },
      });
      dispatch({
        type: actions.FORM_EVALUATION_FACTOR_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_EVALUATION_FACTOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_EVALUATION_FACTOR,
        payload: false,
      });
    }
  };

export const deleteEvaluationFactor = (id, index, offset, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_EVALUATION_FACTOR,
      payload: true,
    });
    await MetricEvaluationFactorServices.deleteEvaluationFactor(id);
    const { data, count } = getState().metricEvaluationFactor.evaluationFactor;
    const { data: dataAll, count: countAll } = getState().metricEvaluationFactor.evaluationFactorAll;
    const { data: dataAnio } = getState().metricEvaluationFactor.evaluationFactorAnio;
    let _data = data.slice();
    let _dataAll = dataAll.slice();
    let _dataAnio = dataAnio.slice();

    if(_dataAll[index+offset+1]){
      const _data1 = {
        valor_minimo:_dataAll[index+offset].valor_minimo
      }
      const _resp = await MetricEvaluationFactorServices.editEvaluationFactor(_dataAll[index+offset+1].id, _data1);
      if(index+1){
        _data[index+1] = _resp.data;
      }
      _dataAll[index+offset+1] = _resp.data;
    }
    _data.splice(index, 1);
    _dataAll.splice(index+offset, 1);

    if(_data[count-2]){
      setInicialValorMinimo(_data[count-2].valor_maximo)
    }else{
      setInicialValorMinimo(0)
    }
    dispatch({
      type: actions.GET_EVALUATION_FACTOR,
      payload: {
        evaluationFactor:{data: _data,count: count - 1},
        evaluationFactorAll:{data: _dataAll,count: countAll - 1},
        evaluationFactorAnio: {data: dataAnio}
      },
    });
    dispatch({
      type: actions.EVALUATION_FACTOR_FALLA,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.EVALUATION_FACTOR_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_EVALUATION_FACTOR,
      payload: false,
    });
  }
};
